import { useEffect, useState, useCallback } from 'react';

/*
  État de connectivité.

  navigator.onLine ne suffit pas : il ment souvent (dit « en ligne » derrière un
  portail captif, ou reste « en ligne » quand le réseau mobile a lâché). On le
  prend comme INDICE, mais la vérité vient des requêtes elles-mêmes : le code
  d'écran appelle `signalerEchecReseau()` quand une requête échoue sans réponse,
  et `signalerSucces()` quand une passe. La bannière reflète ce vécu réel.
*/
export default function useConnectivite() {
  const [enLigne, setEnLigne] = useState(() => (typeof navigator !== 'undefined' ? navigator.onLine !== false : true));

  useEffect(() => {
    const monte = () => setEnLigne(true);
    const demonte = () => setEnLigne(false);
    window.addEventListener('online', monte);
    window.addEventListener('offline', demonte);
    return () => {
      window.removeEventListener('online', monte);
      window.removeEventListener('offline', demonte);
    };
  }, []);

  // Le vécu des requêtes prime sur navigator.onLine.
  const signalerEchecReseau = useCallback(() => setEnLigne(false), []);
  const signalerSucces = useCallback(() => setEnLigne(true), []);

  return { enLigne, signalerEchecReseau, signalerSucces };
}
